import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Users, Target, TrendingUp, Award } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PreCompPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {/* Back Button */}
      <div className="bg-white border-b border-gray-200 pt-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="inline-flex items-center text-slate-600 hover:text-slate-900 transition">
            <ArrowLeft className="w-5 h-5 mr-2" />
            <span className="font-semibold">Back to Home</span>
          </Link>
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold mb-4">
            Ages 8-11 • Coach's Invitation Only
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Pre-Comp Division
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Designed for motivated players transitioning from recreational soccer into a more structured, competitive training environment.
          </p>
        </div>

        {/* What to Know */}
        <section className="bg-white rounded-2xl border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">What to Know</h2>
          <p className="text-lg text-slate-700 leading-relaxed">
            The Pre-Comp Division is designed for motivated players transitioning from recreational soccer into a more structured, competitive training environment. This program bridges the gap between recreational play and full competitive commitment.
          </p>
        </section>

        {/* Why Pre-Comp */}
        <section className="bg-gradient-to-br from-blue-50 to-slate-50 rounded-2xl border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-6">Why Pre-Comp?</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <div className="bg-green-600 rounded-lg p-3">
                <Target className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-2">Focused Technical Development</h3>
                <p className="text-slate-600">Emphasis on refining individual skills and ball mastery</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="bg-green-600 rounded-lg p-3">
                <Users className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-2">Introduction to Tactical Principles</h3>
                <p className="text-slate-600">Learn positional play and game understanding</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="bg-green-600 rounded-lg p-3">
                <TrendingUp className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-2">Increased Commitment</h3>
                <p className="text-slate-600">More training sessions and accountability</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="bg-green-600 rounded-lg p-3">
                <Award className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-2">Evaluation Pathway</h3>
                <p className="text-slate-600">Clear path into Competitive Division</p>
              </div>
            </div>
          </div>
        </section>

        {/* Registration CTA */}
        <section className="bg-slate-900 rounded-2xl p-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Register for Evaluation</h2>
          <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto">
            Pre-Comp players must be evaluated before joining. Click below to begin the registration and evaluation process.
          </p>
          <a
            href="https://register.teamsnap.com/form/awo3RZ3TmE6mqKPqY9Lsh"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-green-700 transition"
          >
            Register for Evaluation
          </a>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PreCompPage;